import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import EntityManagementScreen from '../common/EntityManagementScreen';

const CohortManagementScreen = () => {
  const [searchParams] = useSearchParams();
  
  // Parse query parameters
  const showEntityEditById = searchParams.get('editId') || null;
  const showCreateForm = searchParams.get('create') === 'true';
  const showListByDefault = searchParams.get('showList') !== 'false'; // Default to true unless explicitly set to false

  return (
    <EntityManagementScreen 
      entityName="Cohort"
      fieldsToHide={["Id", "CreatedAt", "UpdatedAt", "CreatedBy", "UpdatedBy", "SubjectIds"]}
      showEntityEditById={showEntityEditById}
      showCreateForm={showCreateForm}
      showListByDefault={showListByDefault}
      extraHeaderActions={(refreshList) => (
        <Button
          type="primary"
          size="small"
          icon={<PlusOutlined />}
          onClick={() => {
            const params = new URLSearchParams(window.location.search);
            params.set('create', 'true');
            window.location.href = `/cohorts?${params.toString()}`;
          }}
        >
          Create Upload Session
        </Button>
      )}
    />
  );
};

export default CohortManagementScreen;
